/**
 * Datas da cortesia de plano (change billing-plans). A API guarda o fim da
 * cortesia como instante exclusivo; o operador pensa em "vale até o dia X".
 * As duas pontas se encontram no calendário de São Paulo, o mesmo do Billing.
 */

const DAY_MS = 86_400_000;

const saoPauloDate = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', dateStyle: 'short' });

/** "AAAA-MM-DD" de hoje mais `days` dias, no calendário de São Paulo. */
export function saoPauloIsoDate(days = 0, now: number = Date.now()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date(now + days * DAY_MS));
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

/**
 * O fim (exclusivo) da cortesia que vale até o fim do dia `lastDayIso` em São
 * Paulo: a meia-noite do dia seguinte. São Paulo não tem horário de verão desde
 * 2019, daí o deslocamento fixo de -03:00.
 */
export function overrideEndsAtFor(lastDayIso: string): string {
  const startOfLastDay = Date.parse(`${lastDayIso}T00:00:00-03:00`);
  return new Date(startOfLastDay + DAY_MS).toISOString();
}

/** O último dia em que a cortesia vale ("DD/MM/AAAA"): o dia de um instante antes do fim. */
export function overrideLastDay(endsAt: string): string {
  return saoPauloDate.format(new Date(Date.parse(endsAt) - 1));
}
